import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Breadcrumb from '../Common/Breadcrumb';
import Footer from '../Common/Footer';
import Helper from '../../../Helper';
import HttpRequest from '../../../Libraries/HttpRequest/HttpRequest';
import DataTable from '../Datatable/Index';
import Pagination from '../Pagination/Index';
import api from '../../../Api'
import { Avatar } from 'antd';

let page_no = 1;
let search_keyword = '';

function Index() {
  const [paginationData, setPaginationData] = useState({});
  const [cmsUsers, setCmsUsers] = useState([]);

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {
    let params = {
      page: page_no,
    }
    params = Helper.makeQueryStingFromJson(params);
    let admin_route = api.get_user;
    let url = admin_route.url + params;
    let response = await HttpRequest.makeRequest(admin_route.method, url)
    setCmsUsers(response.data.data)
    setPaginationData(response.data.paginate);
  }

  const pageChange = (page) => {
    page_no = page
    getData()
  }

  let columns = [
    {
      type: 'callback',
      title: '',
      key: 'slug',
      sort: false,
      cb: record => <Avatar src={record?.image_path ? Helper.generateImageURL(record?.image_path) : '/images/placeholder.jpg'} />
    },
    {
      type: 'callback',
      title: 'Name',
      key: 'full_name',
      sort: false,
      cb: record => <p>{record.first_name + " " + record.last_name}</p>
    },
    {
      type: 'text',
      title: 'Email',
      key: 'email',
      sort: false,
    },
    {
      type: 'text',
      title: 'Address',
      key: 'address',
      sort: false,
    },
    {
      type: 'timestamp',
      title: 'Created At',
      key: 'created_at',
      sort: true,
    },
    // {
    //   type: 'action',
    //   title: 'Action',
    //   action_cb: (record) => {
    //     return (
    //       <>
    //         <Link className='btn btn-xs btn-primary' to={+ `admin/cms-users/edit/${record.slug}`}><i className='fa fa-pencil'></i></Link>
    //         <Link className='btn btn-xs btn-danger' to='#'><i className='fa fa-trash'></i></Link>
    //       </>
    //     )
    //   }
    // },
  ];

  let config = {
    // bulk_delete: true,
    // search: true,
    // bulk_delete_cb: bulkDelete,
    // filter_cb: filter
  }

  return (
    <>
      <Header />
      <Sidebar />
      <Breadcrumb page_title='User Management' />
      <section className="main-content">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-default">
                <div className="row">
                  <div className="col-md-6">
                    User Listing
                  </div>
                  {/* <div className="col-md-6">
                                  <Link className="btn btn-info pull-right" to={+ 'admin/cms-users/add'}>Add Cms User</Link>
                              </div> */}
                </div>
              </div>
              <div className="card-body">
                <div className='row'>
                  <div className='col-md-12'>
                    <DataTable columns={columns} config={config} data={cmsUsers} />
                  </div>
                  <div className='col-md-12'>
                    <nav className='pull-right'>
                      <Pagination paginationData={paginationData} callback={pageChange} />
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  )
}
export default React.memo(Index)
